import { HotelsPage, HotelSearchResultsSlot } from '@honeycomb/ui';
import { getPageAndGlobalProps } from '@honeycomb/data';
import { GetServerSidePropsContext } from 'next';
import { useHoneycombTheme, HoneycombThemeProvider } from '@honeycomb/ui-core';
import { HotelSrpUsps } from '../../components/HotelSrpUsps';

export default function Hotels(): React.JSX.Element {
    const { theme } = useHoneycombTheme();
    const { palette } = theme;

    return (
        <HoneycombThemeProvider theme={{ palette: { background: { body: palette.background.offset } } }}>
            <HotelsPage contentRegionOne={<HotelSrpUsps />} hotelSearchResultsSlot={HotelSearchResultsSlot} />;
        </HoneycombThemeProvider>
    );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
    return getPageAndGlobalProps(context);
}
